import React from 'react';
import PropTypes from 'prop-types';
import { ComposedChart, Bar, XAxis, YAxis, LabelList } from 'recharts';

const Colors = [
  '#FF8700',
  '#FFE200',
  '#84FF00',
  '#00C513',
  '#2F9FF6',
  '#5418EF',
  '#08944A',
  '#212121',
  '#3357FF',
];

const getPath = (x, y, width, height, borderRadius) => {
  console.log();
  return `
    M${x},${y + height - borderRadius}
    Q${x},${y + height} ${x + borderRadius},${y + height}
    L${x + width - borderRadius},${y + height}
    Q${x + width},${y + height} ${x + width},${y + height - borderRadius}
    L${x + width},${y + borderRadius}
    Q${x + width},${y} ${x + width - borderRadius},${y}
    L${x + borderRadius},${y}
    Q${x},${y} ${x},${y + borderRadius}
    Z`;
};

const RoundedRectangularBar = props => {
  const { fill, x, y, width, height, borderRadius } = props;

  return (
    <path
      d={getPath(x, y, width, height, borderRadius)}
      stroke="none"
      fill={fill}
    />
  );
};

const CustomizedLabel = props => {
  const { x, y, value } = props;

  return (
    <text
      x={x + (value / 100) * 330 + 13}
      y={y + 11}
      fill="#000"
      textAnchor="middle"
    >
      {value}
    </text>
  );
};

const Heights = [90, 140, 190, 250, 300, 350, 400, 450, 500, 550, 600];

export default function HorizontalBar({ skillAnalysis }) {
  const data = skillAnalysis?.map((item, index) => {
    const obj = {
      label: item?.skill_name,
      value: item?.skill_score,
      fill: Colors[index],
    };

    return obj;
  });

  return (
    <ComposedChart
      layout="vertical"
      width={550}
      height={Heights[data.length - 1]}
      data={data}
      margin={{
        top: 16,
        right: 20,
        bottom: 20,
        left: 80,
      }}
    >
      <XAxis type="number" domain={[0, 120]} hide />
      <YAxis
        dataKey="label"
        type="category"
        scale="band"
        axisLine={{
          display: 'none',
        }}
        tickLine={{ display: 'none' }}
        tick={({ x, y, payload }) => (
          <foreignObject x={x - 130} y={y + 13} width={110} height={40}>
            <div style={{
              width: '110px',
              overflowWrap: 'anywhere',
              hyphens: 'auto',
              fontSize: '14px',
            }}>
              {payload.value}
            </div>
          </foreignObject>
        )}
      />

      {/* <Tooltip /> */}
      <Bar
        dataKey="value"
        shape={<RoundedRectangularBar borderRadius={7} />} // Adjust the borderRadius as needed
        fill="#413ea0"
        barSize={12}
      >
        <LabelList dataKey="value" content={<CustomizedLabel />} />
      </Bar>
    </ComposedChart>
  );
}

HorizontalBar.propTypes = {
  skillAnalysis: PropTypes.object,
};
